/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planning_Api_Errors_Periode_OngeldigInputs */

const nl_planning_api_errors_periode_ongeldig = /** @type {(inputs: Planning_Api_Errors_Periode_OngeldigInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een begin en eind binnen het schooljaar, met het eind op of na het begin.`)
};

/**

* @param {Planning_Api_Errors_Periode_OngeldigInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const planning_api_errors_periode_ongeldig = /** @type {((inputs?: Planning_Api_Errors_Periode_OngeldigInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planning_Api_Errors_Periode_OngeldigInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_planning_api_errors_periode_ongeldig(inputs)
});
export { planning_api_errors_periode_ongeldig as "planning.api_errors.periode_ongeldig" }